import { render } from "./AlertMessage.vue?vue&type=template&id=168a67ff&scoped=true"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"

import "./AlertMessage.vue?vue&type=style&index=0&id=168a67ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168a67ff"],['__file',"src/scripts/common/AlertMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "168a67ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('168a67ff', __exports__)) {
    api.reload('168a67ff', __exports__)
  }
  
  module.hot.accept("./AlertMessage.vue?vue&type=template&id=168a67ff&scoped=true", () => {
    api.rerender('168a67ff', render)
  })

}


export default __exports__